/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Back_To_CourseInputs */

const en_player_back_to_course = /** @type {(inputs: Player_Back_To_CourseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to course`)
};

const ja_player_back_to_course = /** @type {(inputs: Player_Back_To_CourseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コースに戻る`)
};

const fr_player_back_to_course = /** @type {(inputs: Player_Back_To_CourseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retour au cours`)
};

const de_player_back_to_course = /** @type {(inputs: Player_Back_To_CourseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück zum Kurs`)
};

/**
* | output |
* | --- |
* | "Back to course" |
*
* @param {Player_Back_To_CourseInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const player_back_to_course = /** @type {((inputs?: Player_Back_To_CourseInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Back_To_CourseInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_player_back_to_course(inputs)
	if (locale === "ja") return ja_player_back_to_course(inputs)
	if (locale === "fr") return fr_player_back_to_course(inputs)
	return de_player_back_to_course(inputs)
});